import React from 'react'

const BlogSingle = () => {
    return (
        <div>
            
        </div>
    )
}

export default BlogSingle
